import { Head, usePage } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminUsersIndex } from '@/types';
import { CreateAdminDialog } from './components/CreateAdminDialog';
import { UsersTable } from './components/UsersTable';

export default function Index({ admins, title }: AdminUsersIndex) {
  // `onlyAdminFull()` handed the Next page the signed-in identity; here it is the
  // shared `auth` prop (G9). The table hides the delete button on that row.
  const { auth } = usePage().props;

  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Admin Users</h1>
            <p className="text-muted-foreground">
              Manage admin users and their roles
            </p>
          </div>
          <CreateAdminDialog />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Admin Users ({admins.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <UsersTable
              users={admins}
              currentUserEmail={auth.user?.email ?? ''}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
